import * as z from "zod";

export const deleteErrorMessage = {
  name: "deleteErrorMessage" as const,
  input: z.object({
    type: z.enum(["terminal", "retryable"]),
    rawErrorMessage: z.string(),
  }),
  output: z.object({ success: z.boolean() }),
};
